import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IRivenditore} from '../../interfaces/IRivenditore';

class ImportFatturePassiveModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state',
    '$uibModal',
    'store'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: {
      rivenditore: IRivenditore
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private store: ng.a0.storage.IStoreService
  ) {

    $scope.dati = [{xml: undefined, metadati: undefined}];

    $scope.canRemove = () => {
      return $scope.dati.length < 2;
    };

    $scope.addFile = () => {
      $scope.dati.push({xml: undefined, metadati: undefined});
    };

    $scope.removeFile = (index: number) => {
      $scope.dati.splice(index, 1);
    };

    $scope.readFile = (file: File): Promise<string> => {
      const reader = new FileReader();
      return new Promise<string>((resolve, reject) => {
        reader.readAsBinaryString(file);
        reader.onload = (e) => resolve(reader.result as string);
        reader.onerror = (err) => reject(err);
      });
    };

    $scope.loadFile = async (e, tipo: string, index: number) => {
      const files = e.target.files as FileList;
      // console.log(files);
      const filecont = btoa((await $scope.readFile(files[0])));
      // const ab = new Uint8Array(filecont);
      const caricare = $scope.dati[index] || {xml: undefined, metadati: undefined} as typeof $scope.dati[0];
      if (tipo === 'xml') {
        caricare.xml = {file: filecont, name: files[0].name};
      } else {
        caricare.metadati = {file: filecont, name: files[0].name};
      }
      $scope.dati[index] = caricare;

      // console.log($scope.dati);
      $scope.$apply();
    };

    $scope.ok = () => {
      $scope.messaggio = null;

      const dati = (JSON.parse(JSON.stringify($scope.dati)) as typeof $scope.dati).filter(item => {
        if (item.xml === undefined || item.metadati === undefined) {
          return false;
        }
        return true;
      });

      if (dati.length < 1) {
        return;
      }
      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'uploadFatturePassiveModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return store.get('user');
          },
          dati: () => {
            return dati;
          },
          admin: false,
        }
      });
      ConfermaModal.result.finally(() => {
        this.close();
      });

    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const ImportFatturePassiveModalComponent: ng.IComponentOptions = {
  template: require('./import-fatture-passive-modal.html'),
  controller: ImportFatturePassiveModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/import-fatture-passive-modal/import-fatture-passive-modal.ts